import { render, staticRenderFns } from "./GithubModal.vue?vue&type=template&id=37b984b8&"
import script from "./GithubModal.vue?vue&type=script&lang=js&"
export * from "./GithubModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports